export default {"src":"/_next/static/media/logo.5e50db3b.svg","height":31,"width":139};